// extracted by mini-css-extract-plugin
export default {"logoWrap":"logo_logoWrap__QBhcd","logo":"logo_logo__B2e27"};